export const API_STALE_TIME = 5000; // 5 seconds
